import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'solar-repairs-and-maintenance-sydney';
const serviceId = 4
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Solar Repairs & Maintenance Sydney  | ${BUSINESS_NAME}`,
        description: "Professional servicing for panels, inverters, and systems. Keep your solar system performing at its best with routine checks and expert repairs.",
        keywords: "solar repairs Sydney, solar maintenance services, solar panel servicing, inverter repairs, solar system checks, professional solar technicians, residential solar repairs, commercial solar maintenance, emergency solar repairs, sustainable energy solutions",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Solar Repairs & Maintenance',
    description: 'Professional servicing for panels, inverters, and systems. Keep your solar system performing at its best with routine checks and expert repairs.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
